module.exports = __webpack_public_path__ + "img/icon-warning-landslide-orange.43f667cd.svg";